/**
 * Service Worker Registration for Priyofy PWA
 * Handles offline caching setup, SW update lifecycle listeners, and status reporting.
 */

export function registerServiceWorker() {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    const hostname = window.location.hostname;
    const isDevOrPreview = Boolean((import.meta as any).env?.DEV) ||
      hostname.includes('ais-dev') ||
      hostname.includes('ais-pre') ||
      hostname.includes('run.app') ||
      hostname === 'localhost' ||
      hostname === '127.0.0.1';

    // In dev / preview container environments, unregister service workers to avoid stale HTML/JS caching issues
    if (isDevOrPreview) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister().catch(() => {});
        }
      }).catch(() => {});

      if ('caches' in window) {
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name).catch(() => {});
          }
        }).catch(() => {});
      }
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = '/sw.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[SW] ServiceWorker registration successful with scope:', registration.scope);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New content is available and will be used when all tabs are closed or SW skipWaiting called.
                  console.log('[SW] New PWA update available. Refresh to apply updates.');
                  
                  // Dispatch custom event for UI banners if needed
                  window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
                } else {
                  // Content is cached for offline use.
                  console.log('[SW] Content cached for offline use.');
                  window.dispatchEvent(new CustomEvent('swCached'));
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('[SW] ServiceWorker registration failed:', error);
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
